/* @flow */
import React, { type Node } from 'react';
import type { TKnowledge } from '../../types/helpful';
import { ArticleColored, ArticleItem, ArticleText, ArticleTitle, KnowledgeRubric } from './styles';
import Link from '../../components/Link';

type TProps = {
	item: TKnowledge,
};

const Knowledge = ({ item }: TProps): Node => (
	<ArticleItem>
		<ArticleColored bgColor="white">
			<KnowledgeRubric>{item.category.title}</KnowledgeRubric>
			<ArticleTitle>
				<Link to={`/znanie/${item.slug}/`}>{item.title}</Link>
			</ArticleTitle>
			<ArticleText dangerouslySetInnerHTML={{ __html: item.previewDescription }} />
		</ArticleColored>
	</ArticleItem>
);

export default Knowledge;
